// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"208":"mandoob_users","346":"stores","486":"orders","818":"auth"}[chunkId] || chunkId) + "." + {"15":"d046be26","195":"f2c00a27","208":"b270c687","346":"d239ba39","484":"81ba1010","486":"8b6fa4f2","818":"cc51b271"}[chunkId] + ".js";
};